// source: messages/schemas/task_result.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var messages_enums_task_status_pb = require("../../messages/enums/task_status_pb.js");
goog.object.extend(proto, messages_enums_task_status_pb);
var messages_schemas_source_pb = require("../../messages/schemas/source_pb.js");
goog.object.extend(proto, messages_schemas_source_pb);
goog.exportSymbol("proto.TaskResult", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TaskResult = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.TaskResult.repeatedFields_,
    null,
  );
};
goog.inherits(proto.TaskResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TaskResult.displayName = "proto.TaskResult";
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TaskResult.repeatedFields_ = [3];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.TaskResult.prototype.toObject = function (opt_includeInstance) {
    return proto.TaskResult.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.TaskResult} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.TaskResult.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        source:
          (f = msg.getSource()) &&
          messages_schemas_source_pb.Source.toObject(includeInstance, f),
        status: jspb.Message.getFieldWithDefault(msg, 2, 0),
        errorsList:
          (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TaskResult}
 */
proto.TaskResult.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TaskResult();
  return proto.TaskResult.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TaskResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TaskResult}
 */
proto.TaskResult.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new messages_schemas_source_pb.Source();
        reader.readMessage(
          value,
          messages_schemas_source_pb.Source.deserializeBinaryFromReader,
        );
        msg.setSource(value);
        break;
      case 2:
        var value = /** @type {!proto.TaskStatus} */ reader.readEnum();
        msg.setStatus(value);
        break;
      case 3:
        var value = /** @type {string} */ reader.readString();
        msg.addErrors(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TaskResult.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.TaskResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TaskResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TaskResult.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_schemas_source_pb.Source.serializeBinaryToWriter,
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(3, f);
  }
};

/**
 * optional Source source = 1;
 * @return {?proto.Source}
 */
proto.TaskResult.prototype.getSource = function () {
  return /** @type{?proto.Source} */ jspb.Message.getWrapperField(
    this,
    messages_schemas_source_pb.Source,
    1,
  );
};

/** @param {?proto.Source|undefined} value */
proto.TaskResult.prototype.setSource = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.TaskResult.prototype.clearSource = function () {
  this.setSource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.TaskResult.prototype.hasSource = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional TaskStatus status = 2;
 * @return {!proto.TaskStatus}
 */
proto.TaskResult.prototype.getStatus = function () {
  return /** @type {!proto.TaskStatus} */ jspb.Message.getFieldWithDefault(
    this,
    2,
    0,
  );
};

/** @param {!proto.TaskStatus} value */
proto.TaskResult.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * repeated string errors = 3;
 * @return {!Array<string>}
 */
proto.TaskResult.prototype.getErrorsList = function () {
  return /** @type {!Array<string>} */ jspb.Message.getRepeatedField(this, 3);
};

/** @param {!Array<string>} value */
proto.TaskResult.prototype.setErrorsList = function (value) {
  jspb.Message.setField(this, 3, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.TaskResult.prototype.addErrors = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.TaskResult.prototype.clearErrorsList = function () {
  this.setErrorsList([]);
};

goog.object.extend(exports, proto);
